import { Component  } from '@angular/core';
import { LoginService } from 'app/services/login/login.service';

@Component({
  selector: 'app-recibo',
  templateUrl: './recibo.component.html',
  styleUrls: ['./recibo.component.scss']
})
export class ReciboComponent   {

  constructor(private loginService:LoginService) { }

 

  clickGuard(){
    this.loginService.clickGuard = true;
 }

}
